import React, { useState }        from "react";
import PrescriptionService        from 'services/prescription.service';
import AuthService                from 'services/auth.service';
import PrescriptionTable          from './PrescriptionTable';
import { Modal }                  from "react-bootstrap";
import CloseBtn                   from 'assets/icons/Close.svg';
import Spinner                    from 'react-bootstrap/Spinner';

function MedicinesConfirmModal({setShowMedicinesConfirm, showMedicinesConfirm, medicines, medicineLabel, getTotal, PickUpLocation, chat_id, setPrescribed}) {
  const [submitting, setSubmitting] = useState(false); 

  const submitMedicines = () => {
    setSubmitting(true);
    const newMedicines = medicines.map(({medicine, ...rest}) => {
      return rest;
    });
    const params = {
      chat_session_id: chat_id,
      medicines: newMedicines
    }

    PrescriptionService.submitPrescription(params).then(
      (data) => {
        setSubmitting(false);
        setPrescribed(data.prescription.id)
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }

  return (
    <Modal className="medicine-details-modal" size="lg" show={showMedicinesConfirm} onHide={() => {setShowMedicinesConfirm(false)}} backdrop="static" keyboard={false}>
      <Modal.Header>
        <button type="button" className="close" onClick={() => {setShowMedicinesConfirm(false)}}>
            <img src={ CloseBtn } alt="modal-close" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h6>Confirmation</h6>
        <p>Please note that all the following medications is prescribed correctly. You are not able to retrieve or make changes once you send it to the patient.</p>
        <PrescriptionTable medicines={medicines} getTotal={getTotal} medicineLabel={medicineLabel}/>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex justify-content-between align-items-end">
          <PickUpLocation />
          <div>
            {submitting ? <Spinner animation="border" className="spinner"/> : <button className="btn btn-danger" onClick={submitMedicines}>Confirm & Send</button> }
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default MedicinesConfirmModal;
